import { Injectable } from '@angular/core';
import { CustomizedHttpService } from '../base/customized-http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionTrackerService {
  constructor(private httpService: CustomizedHttpService) {}

  public initSessionTracker(): Observable<null> {
    return this.httpService.post<any, null>('SessionTracker/InitSessionTracker', { XRefererFor: document.referrer });
  }

  public initMobileUserTracker(deviceType: string): Observable<null> {
    return this.httpService.post<any, null>('SessionTracker/AddMobileTracking', { deviceType: deviceType });
  }

  public validateCaptchaToken(token: string) {
    return this.httpService.post<any, any>('tracker/validateCaptchaToken', { token: token });
  }
}
